<template>
  <form class="usage-terms-personalize-form-preview-panel"
        :class="{ 'usage-terms-personalize-form-preview-panel_open': isOpen }"
        @submit.prevent="handleFormSubmit"
        @click="click">
    <div class="usage-terms-personalize-form-preview-panel-header">
      <p class="usage-terms-personalize-form-preview-panel-header-title">{{$t('message.loginPersonalize.message.changeRegistration')}}</p>
      <i class="mdi mdi-chevron-down pointer"
         :class="{ 'mdi-chevron-down': !isOpen, 'mdi-chevron-up': isOpen}"
         @click="toggleBodyOpen"></i>
    </div>

    <div class="usage-terms-personalize-form-preview-panel-body">
      <div v-if="!isPartner" class="usage-terms-personalize-form-preview-panel-section usage-terms-personalize-form-preview-panel-section_default">
        <checkbox v-model="value.isDefault"
                  label="Definir como padrão"
                  center />
      </div>

      <login-personalize-preview-panel-section-local :item="value" @saved="setConfig" />

      <login-personalize-preview-panel-section-ssid v-if="!isPartner" :item="value" @saved="onSSIDSave" />

      <div class="usage-terms-personalize-form-preview-panel-section">
        <p class="usage-terms-personalize-form-preview-panel-section-title">{{$t('message.loginPersonalize.message.predefined')}}</p>

        <div class="usage-terms-personalize-form-preview-panel-section-colors">
          <div v-for="(style, index) in predefinedStyles"
               :key="index"
               :style="{ background: style.preview }"
               :class="{'usage-terms-personalize-form-preview-panel-section-colors-item_white': style.id === 'WHITE'}"
               class="usage-terms-personalize-form-preview-panel-section-colors-item"
               @click="emitPredefinedStyle(style)"></div>

        </div>
      </div>

      <div class="usage-terms-personalize-form-preview-panel-section">
        <p class="usage-terms-personalize-form-preview-panel-section-title">{{$t('message.loginPersonalize.message.custom')}}</p>

        <color-picker :value="value.registerStyle.bg"
                      :data-control-name="$t('message.loginPersonalize.message.background')"
                      type="BACKGROUND"
                      :data-show-checkbox="false"
                      :eyedropper="true"
                      hex
                      :interaction="value"
                      entity="captiveStyle"
                      @input="emitBgColor"></color-picker>

        <color-picker :value="value.registerStyle.text"
                      :data-control-name="$t('message.loginPersonalize.message.font')"
                      type="FONT"
                      :data-show-checkbox="false"
                      :eyedropper="true"
                      hex
                      :interaction="value"
                      entity="captiveStyle"
                      @input="emitTextColor"></color-picker>

        <color-picker :value="value.registerStyle.button.bg"
                      :data-control-name="$t('message.loginPersonalize.message.buttonBackground')"
                      type="BACKGROUND"
                      :data-show-checkbox="false"
                      :eyedropper="true"
                      hex
                      :interaction="value"
                      entity="captiveStyle"
                      @input="emitButtonBgColor"></color-picker>

        <color-picker :value="value.registerStyle.button.color"
                      :data-control-name="$t('message.loginPersonalize.message.buttonFont')"
                      type="FONT"
                      :data-show-checkbox="false"
                      :eyedropper="true"
                      hex
                      :interaction="value"
                      entity="captiveStyle"
                      @input="emitButtonTextColor"></color-picker>

      </div>

      <login-personalize-preview-panel-section-logo :item="value"
                                                    @set-temporary-logo="setTemporaryLogo"
                                                    @remove-temporary-logo="removeTemporaryLogo"
                                                    @saved="setLogo"
                                                    ref="sectionLogo"/>

      <login-personalize-preview-panel-section-background :item="value"
                                                          @set-temporary-img="setTemporaryImage"
                                                          @remove-temporary-img="removeTemporaryImages"
                                                          @saved="setBackgroundImage"
                                                          ref="sectionBackground"/>

      <div class="usage-terms-personalize-form-preview-panel-section">
        <div class="flex">
          <p class="usage-terms-personalize-form-preview-panel-section-title">{{$t('message.loginPersonalize.message.initialPhrase')}}</p>
          <i class="mdi mdi-help-circle-outline pointer" v-tooltip="'Limite de 150 caracteres'"></i>
        </div>

        <html-editor :value="value.phraseLogin"
                     contentHeight="130px"
                     character-limit="150"
                     small
                     @input="emitLoginPhrase"></html-editor>
      </div>

    </div>

    <div class="usage-terms-personalize-form-preview-panel-section usage-terms-personalize-form-preview-panel-section_submit"
         :style="sectionSubmitStyle">
      <button class="btn btn-extra-round btn-primary"
              type="submit">{{$t('message.generics.message.save')}}</button>
    </div>

  </form>
</template>

<script>
import LoginPersonalizePreviewPanelSectionBackground from "@components/modules/login-personalize/preview/panel/section/background/LoginPersonalizePreviewPanelSectionBackground";
import LoginPersonalizePreviewPanelSectionLogo from "@components/modules/login-personalize/preview/panel/section/logo/LoginPersonalizePreviewPanelSectionLogo";
import LoginPersonalizePreviewPanelSectionLocal from "@components/modules/login-personalize/preview/panel/section/local/LoginPersonalizePreviewPanelSectionLocal";
import LoginPersonalizePreviewPanelSectionSsid from "@components/modules/login-personalize/preview/panel/section/ssid/LoginPersonalizePreviewPanelSectionSsid";
import HtmlEditor from "@components/form/HtmlEditor";
import colors from "@packages/colors";
import EventBus from "@packages/event-bus";
import ColorPicker from "@views/interactions/components/SidePanel/components/ColorPicker.vue";
import _ from "lodash";
import Checkbox from "@components/Checkbox";

export default {
  components: {
    ColorPicker,
    HtmlEditor,
    Checkbox,
    LoginPersonalizePreviewPanelSectionLocal,
    LoginPersonalizePreviewPanelSectionSsid,
    LoginPersonalizePreviewPanelSectionBackground,
    LoginPersonalizePreviewPanelSectionLogo
  },

  props: {
    value: {
      type: Object,
      default: () => {
        return {
          logo: "",
          registerStyle: {
            bg: "#2a7155",
            button: {
              bg: "#000",
              color: "#fff",
            },
            text: "#fff",
          },
          isDefaultGreen: true,
          phraseLogin: "",
        };
      },
    },
  },

  data() {
    return {
      predefinedStyles: colors.personalize.predefinedStyles,
      isOpen: true,
      notAllowedText: this.$t("message.loginPersonalize.message.typeDisabled"),
      temporaryImageMobile: undefined,
      temporaryImageDesktop: undefined,
      temporaryLogo: undefined
    };
  },

  computed: {
    loggedUser() {
      return this.$store.state.users.user;
    },
    permissions() {
      return this.$store.state.users.user.permissions;
    },
    isPartner() {
        return this.loggedUser.tipo === "PARCEIRO"
    },
    sectionSubmitStyle() {
      return {
        "display": `${this.isOpen ? '' : 'none'}`
      }
    },
    hasTemporaryImage() {
      return this.temporaryImageMobile || this.temporaryImageDesktop
    }
  },

  methods: {
    setBackgroundImage({ backgroundId, isMobile }) {
      const config = {
        ...this.value,
      };

      if (isMobile) {
        config.registerBackground = backgroundId;
      } else {
        config.registerBackgroundDesktop = backgroundId;
      }

      this.$emit("input", config);
    },
    setTemporaryImage({base64Img, isMobile}) {
      if (isMobile) {
        this.temporaryImageMobile = base64Img;
        this.$emit("set-temporary-image", base64Img);
      } else {
        this.temporaryImageDesktop = base64Img;
      }
    },
    removeTemporaryImages() {
      this.temporaryImageMobile = undefined;
      this.temporaryImageDesktop = undefined;
      this.$emit("set-temporary-image", undefined);
    },
    setTemporaryLogo({base64Logo}) {
      this.temporaryLogo = base64Logo;
      this.$emit("set-temporary-logo", base64Logo);
    },
    setLogo() {
      const value = _.cloneDeep(this.value);

      value.logo = this.temporaryLogo;

      this.$emit("input", value);
    },
    removeTemporaryLogo() {
      this.temporaryLogo = undefined;
      this.$emit("set-temporary-logo", undefined);
    },
    async setConfig(config) {
      this.$emit("input", config);
    },
    async onSSIDSave(value){
        await this.setConfig(value);

        this.handleFormSubmit()
    },
    clearLogoInput() {
      this.$refs.sectionLogo.$refs.fileInput.value = "";
    },
    toggleBodyOpen() {
      this.isOpen = !this.isOpen;
    },
    hasGreenLogo(style) {
      return (
        style.id === colors.personalize.styleIds.WHITE ||
        style.id === colors.personalize.styleIds.YELLOW
      );
    },
    emitPredefinedStyle(style) {
      const value = _.cloneDeep(this.value);

      value.registerStyle = {
        bg: style.bg,
        button: {
          bg: style.button.bg,
          color: style.button.color,
        },
        text: style.text,
      };

      value.isDefaultGreen = this.hasGreenLogo(style);

      value.logo = null;

      value.registerBackground = null;
      value.registerBackgroundDesktop = null;

      this.clearLogoInput();
      this.removeTemporaryImages();

      this.$emit("input", value);
    },
    emitTextColor(color) {
      const value = _.cloneDeep(this.value);

      value.registerStyle.text = `${color}`;

      this.$emit("input", value);
    },
    emitButtonBgColor(color) {
      const value = _.cloneDeep(this.value);

      value.registerStyle.button.bg = `${color}`;

      this.$emit("input", value);
    },
    emitButtonTextColor(color) {
      const value = _.cloneDeep(this.value);

      value.registerStyle.button.color = `${color}`;

      this.$emit("input", value);
    },
    async addNewImage(event) {
      const fileList = event.target.files;

      const base64Image = await this.fileToBase64Image(fileList[0]);

      const value = _.cloneDeep(this.value);

      value.logo = base64Image;

      this.$emit("input", value);

      this.$api.core.account.captiveStyle.logo({
        styleId: this.value.id,
        file: fileList[0],
      });
    },
    fileToBase64Image(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (ev) => {
          resolve(ev.target.result);
        };

        reader.onerror = () => {
          reject(reader.error);
        };

        reader.readAsDataURL(file);
      });
    },
    emitBgColor(color) {
      const value = _.cloneDeep(this.value);

      value.registerStyle.bg = color;

      value.registerBackground = null;
      value.registerBackgroundDesktop = null;

      this.removeTemporaryImages();
      this.$emit("input", value);
    },
    emitLoginPhrase(text) {
      const value = _.cloneDeep(this.value);

      value.phraseLogin = text;

      this.$emit("input", value);
    },
    async handleFormSubmit() {
      try {
        EventBus.$emit("SHOW_SPINNER");
        if (this.temporaryImageMobile) {
          const options = {
            isMobile: true,
            isLastRequest: this.temporaryImageDesktop ? false : true
          }
          await this.$refs.sectionBackground.saveImage(options)
        }

        if (this.temporaryImageDesktop) {
          const options = {
            isMobile: false,
            isLastRequest: true
          }
          await this.$refs.sectionBackground.saveImage(options)
        }

        if(this.temporaryLogo) {
          await this.$refs.sectionLogo.saveLogo()
        }

        await this.$api.core.account.captiveStyle.edit({
          styleId: this.value.id,
          data: {
            name: this.value.name,
            isDefault: this.value.isDefault,
            isDefaultGreen: this.value.isDefaultGreen,
            logo: this.value.logo,
            phraseLogin: this.value.phraseLogin,
            registerBackground: this.value.registerBackground,
            registerBackgroundDesktop: this.value.registerBackgroundDesktop,
            localItemFilter: this.value.localItemFilter,
            registerStyle: JSON.stringify(this.value.registerStyle),
            ssidFilter: this.value.ssidFilter,
            allSsidSelected: this.value.allSsidSelected
          },
        });

        this.temporaryImageMobile = undefined;
        this.temporaryImageDesktop = undefined;
        this.temporaryLogo = undefined;

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Estilo salvo com sucesso!",
        });

      } catch (error) {
        //
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    click(evt) {
      evt.stopPropagation();
    },
  },

  mounted() {},

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.usage-terms-personalize-form-preview-panel {
  position: fixed;
  top: 70px;
  right: 10px;
  width: 270px;
  border: 1px solid $grey-1;
  border-radius: 25px;
  background-color: $white;
  box-shadow: $shadow-2;
  z-index: 2;
  max-height: calc(100% - 70px);
  overflow-y: hidden;

  .usage-terms-personalize-form-preview-panel-header {
    padding: 10px 0;
    position: relative;

    .usage-terms-personalize-form-preview-panel-header-title {
      text-align: center;
      margin: 0;
      color: #4d4f5c;
      font-weight: 600;
      font-size: 14px;
    }

    i {
      color: #4d4f5c;
      font-size: 24px;
      left: 20px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .usage-terms-personalize-form-preview-panel-body {
    max-height: 0;
    transition: all 0.2s;
  }

  .usage-terms-personalize-form-preview-panel-section {
    padding: 15px 10px;
    border-bottom: 2px solid $grey-1;

    &.usage-terms-personalize-form-preview-panel-section_default {
      display: flex;
      justify-content: center;
      align-content: center;

      .checkbox {
        margin: 0;

        ::v-deep .v-messages {
          display: none;
        }
      }
    }

    .usage-terms-personalize-form-preview-panel-section-title {
      font-size: 14px;
      color: #4d4f5c;
      font-weight: 600;
      margin: 0 0 10px 0;
    }

    .usage-terms-personalize-form-preview-panel-section-colors {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .usage-terms-personalize-form-preview-panel-section-colors-item {
        background: green;
        width: 45px;
        height: 20px;
        border-radius: 5px;
        margin-bottom: 10px;
        cursor: pointer;

        &.usage-terms-personalize-form-preview-panel-section-colors-item_white {
          border: 1px solid #d6d6d6;
        }
      }
    }

    &.usage-terms-personalize-form-preview-panel-section_image {
      .usage-terms-personalize-form-preview-panel-section_image-button {
        display: flex;
        justify-content: center;

        ::v-deep button {
          border: 1px solid #d6d6d6;
          font-size: 14px;
        }
      }
    }

    &.usage-terms-personalize-form-preview-panel-section_login {
      .usage-terms-personalize-form-preview-panel-section_login-item {
        display: flex;
        justify-content: center;
        margin-bottom: 5px;

        .usage-terms-personalize-form-preview-panel-section_login-item-toggle {
          margin-right: 5px;
        }

        span {
          width: 100px;
          font-size: 14px;
        }

        &.usage-terms-personalize-form-preview-panel-section_login-item_disabled {
          span {
            color: $color-muted;
          }
        }
      }
    }

    &.usage-terms-personalize-form-preview-panel-section_extra-fields {
      .usage-terms-personalize-form-preview-panel-section_extra-fields-button {
        display: flex;
        justify-content: center;

        ::v-deep button {
          border: 1px solid #000;
          font-size: 14px;
        }
      }
    }

    &.usage-terms-personalize-form-preview-panel-section_login-types {
      .usage-terms-personalize-form-preview-panel-section_login-types-button {
        display: flex;
        justify-content: center;

        ::v-deep button {
          border: 1px solid #000;
          font-size: 14px;
        }
      }
    }

    &.usage-terms-personalize-form-preview-panel-section_submit {
      display: flex;
      justify-content: center;
      box-shadow: 1px 6px 8px #000;
      position: sticky;
      bottom: 0;
      background-color: #fff;

      .btn {
        display: flex;
        padding-right: 50px;
        padding-left: 50px;
      }
    }

    .flex {
      display: flex;
      gap: 5px;

      .mdi {
        margin-top: -2px;
      }
    }

    &:last-child {
      border-bottom: none;
    }
  }

  &.usage-terms-personalize-form-preview-panel_open {
    .usage-terms-personalize-form-preview-panel-header {
      border-bottom: 2px solid $grey-1;
    }

    .usage-terms-personalize-form-preview-panel-body {
      max-height: 70vh;
      overflow-y: scroll;
    }
  }
}
</style>
